import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useUIStore } from '../../store/ui';
import { useDealsStore } from '../../store/deals';

export function TopBar() {
  const setShowDealIndex = useUIStore(s => s.setShowDealIndex);
  const dealCount = useDealsStore(s => s.deals.length);
  const [query, setQuery] = useState('');

  return (
    <header className="topbar">
      <div className="brand">
        <img src="/brand/timberline-logo.svg" alt="Timberline" className="brand-logo" />
        <span className="brand-divider">/</span>
        <span className="brand-app">Workbench</span>
      </div>
      <div className="global-search">
        <span style={{ color: 'var(--text-faint)', fontSize: 13 }}>⌕</span>
        <input
          type="text"
          placeholder={`Search ${dealCount} deals · TRS · doc numbers · buyers…`}
          value={query}
          onChange={e => setQuery(e.target.value)}
          onFocus={() => setShowDealIndex(true)}
        />
        <span className="kbd">⌘K</span>
      </div>
      <div className="top-actions">
        <Link to="/select" className="top-link">↔ Switch workspace</Link>
        <a href="https://app.close.com" target="_blank" rel="noreferrer" className="top-link">Close ↗</a>
        <a href="https://airtable.com/appUyPKwR6KLaol3O" target="_blank" rel="noreferrer" className="top-link">Airtable ↗</a>
        <a href="https://recording.weld.gov/web/" target="_blank" rel="noreferrer" className="top-link">Weld Clerk ↗</a>
        <span className="sync-pill">
          <span className="sync-dot"></span>
          <span>API live</span>
        </span>
      </div>
    </header>
  );
}
